import "./AnalyticsConsent.css";

import { Controller } from "@hotwired/stimulus";
import { browserAnalyticsConsentState } from "./AnalyticsConsentState";
import { AnalyticsConsentUi } from "./AnalyticsConsentUi";

export default class AnalyticsConsentController extends Controller<HTMLElement> {
    static targets = ["overlay", "panel", "copy", "accept", "reject", "settings"];
    static values = { containerId: String };

    declare readonly overlayTarget: HTMLElement;
    declare readonly panelTarget: HTMLElement;
    declare readonly copyTarget: HTMLElement;
    declare readonly acceptTarget: HTMLButtonElement;
    declare readonly rejectTarget: HTMLButtonElement;
    declare readonly settingsTarget: HTMLButtonElement;
    declare readonly containerIdValue: string;

    private ui?: AnalyticsConsentUi;

    connect(): void {
        this.ui = new AnalyticsConsentUi({
            documentRef: document,
            windowRef: window,
            overlay: this.overlayTarget,
            panel: this.panelTarget,
            copyArea: this.copyTarget,
            acceptButton: this.acceptTarget,
            rejectButton: this.rejectTarget,
            settingsButton: this.settingsTarget,
            containerId: this.containerIdValue,
            consentState: browserAnalyticsConsentState
        });
        this.ui.connect();
    }

    disconnect(): void {
        this.ui?.disconnect();
        this.ui = undefined;
    }

    accept(event: Event): void {
        event.preventDefault();
        this.ui?.accept();
    }

    reject(event: Event): void {
        event.preventDefault();
        this.ui?.reject();
    }

    openSettings(event: Event): void {
        event.preventDefault();
        this.ui?.openSettings();
    }
}
